import http from "../../utils/http";

export const seminarSessions = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/session/list`, params)
      .then((res) => {
        resolve(res.data.seminarSessions);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const seminars = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/list`, params)
      .then((res) => {
        resolve(res.data.seminars);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const addSeminar = (body) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editSeminar = (body, idx) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addSession = (body) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/session`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editSession = (body, idx) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/session/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const seminarCategories = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/category/list`, params)
      .then((res) => {
        resolve(res.data.categories);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addSeminarCategory = (body) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/category`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editSeminarCategory = (body, idx) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/category/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteSeminarCategories = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/category`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addSeminarRecruitment = (body) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/recruitment`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editSeminarRecruitment = (body, idx) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/recruitment/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const seminarRecruitments = (params) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/recruitment/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSeminarRecruitment = (idx) => {
  return new Promise((resolve, reject) => {
    http.get(`/seminar/recruitment/${idx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteSeminarRecruitment = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/recruitment`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteSeminarSession = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/session`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteSeminar = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const seminarReservations = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/admin/reservation/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editReservations = (idx, body) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/admin/reservation/${idx}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteReservations = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/reservation`, { data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const reservationChangePush = (params) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/admin/reservation/change/push`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const seminarRequests = (params) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/request/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addSeminarRequest = (body) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/request`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editSeminarRequest = (idx, body) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/request/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteSeminarRequests = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/request`, { data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const SeminarRequestReservations = (params) => {
  return new Promise((resolve, reject) => {
    http.post(`/seminar/request/admin/reservation/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteRequestReservations = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`/seminar/request/reservation`, { data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editRequestReservations = (idx, body) => {
  return new Promise((resolve, reject) => {
    http.put(`/seminar/request/admin/reservation/${idx}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};